// Sentry init for the admin SPA. Imported first thing in main.tsx so the
// browser SDK can install its global error / unhandled-rejection listeners
// before any other module runs. A blank/missing VITE_SENTRY_DSN makes this a
// complete no-op, so local dev runs without a Sentry account are unaffected.

import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN?.trim();

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    // Performance off by default — flip to e.g. 0.1 to sample traces.
    tracesSampleRate: 0,
    // Session replay disabled by default (heavyweight). Enable in Sentry
    // project settings via replaysSessionSampleRate / replaysOnErrorSampleRate
    // once you've added the @sentry/replay integration.
  });
}

export { Sentry };
